import React, {Fragment} from "react";
import {ApiUtility} from "../common/ApiUtility";
import {UserForm} from "./UserForm";
import {useModelUpdateEngine} from "../common/hooks/useModelUpdateEngine";
import {ConditionalRenderer} from "../common/ConditionalRenderer";
import {OverlayLoadingIndicator} from "../common/OverlayLoadingIndicator";
import {ConfirmCancelModal} from "../common/ConfirmCancelModal";

export let UpdateUser = function (props) {
    const modelUpdateEngine = useModelUpdateEngine(
        ApiUtility.getUser,
        ApiUtility.updateUser,
        props.userId,
        'user',
        props.afterSuccessfulSave
    );

    return (
        <Fragment>
            <ConditionalRenderer if={modelUpdateEngine.renderableData.loading} renderer={() => (
                <OverlayLoadingIndicator/>
            )}/>
            <ConditionalRenderer if={modelUpdateEngine.renderableData.model} renderer={() => (
                <UserForm
                    cancel={props.cancel}
                    save={modelUpdateEngine.updateModel}
                    onClickDeactivate={modelUpdateEngine.showConfirmDeactivateModal}
                    user={modelUpdateEngine.renderableData.model}
                    isNew={false}
                    headerText="Update User"
                />
            )}/>
            <ConditionalRenderer if={modelUpdateEngine.renderableData.showConfirmDeactivateModal} renderer={() => (
                <ConfirmCancelModal
                    cancel={modelUpdateEngine.hideConfirmDeactivateModal}
                    confirm={modelUpdateEngine.deactivateModel}
                    headerText="Confirm Delete"
                    confirmButtonText="DELETE"
                    warningMessage="Are you sure you want to delete this user?"
                />
            )}/>
        </Fragment>
    );
};
